import { ifAuthenticated, ifNotAuthenticated, ifAdmin } from '@/router/helpers';
import Login from '@/views/Login';
import Index from '@/views/Manage/index';
import i18n from '@/i18n';
import Dashboard from '@/views/Manage/Dashboard';
import Staff from '@/views/Manage/Staff';
import Categories from '@/views/Manage/Categories';
import Banners from '@/views/Manage/Banners';
import Polls from '@/views/Manage/Polls';
import Types from '@/views/Manage/Types';
import News from '@/views/Manage/News';
import NewsForm from '@/views/Manage/NewsForm';
import Galleries from '@/views/Manage/Galleries';
import Contributions from '@/views/Manage/Settings/Contributions';
import Pages from '@/views/Manage/Settings/Pages';
import Socials from '@/views/Manage/Settings/Socials';

export default [
  {
    path: '/',
    name: 'Home',
    component: Login,
    beforeEnter: ifNotAuthenticated,
  },
  {
    path: '/manage',
    component: Index,
    meta: {
      title: 'Manage',
    },
    children: [
      {
        path: '',
        name: 'Dashboard',
        component: Dashboard,
        meta: {
          title: i18n.t('pageTitle.dashboard'),
        },
      },
      {
        path: 'staff',
        name: 'Staff',
        component: Staff,
        meta: {
          title: i18n.t('pageTitle.staff'),
        },
        beforeEnter: ifAdmin,
      },
      {
        path: 'banners',
        name: 'Banners',
        component: Banners,
        meta: {
          title: i18n.t('pageTitle.banners'),
        },
        beforeEnter: ifAdmin,
      },
      {
        path: 'categories',
        name: 'Categories',
        component: Categories,
        meta: {
          title: i18n.t('pageTitle.categories'),
        },
        beforeEnter: ifAdmin,
      },
      {
        path: 'types',
        name: 'Types',
        component: Types,
        meta: {
          title: i18n.t('pageTitle.types'),
        },
        beforeEnter: ifAdmin,
      },
      {
        path: 'polls',
        name: 'Polls',
        component: Polls,
        meta: {
          title: i18n.t('pageTitle.polls'),
        },
      },
      {
        path: 'news',
        name: 'News',
        component: News,
        meta: {
          title: i18n.t('pageTitle.news'),
        },
      },
      {
        path: 'add-news',
        name: 'NewsAdd',
        component: NewsForm,
        meta: {
          title: i18n.t('pageTitle.newsAdd'),
        },
      },
      {
        path: 'edit-news/:id',
        name: 'NewsEdit',
        component: NewsForm,
        meta: {
          title: i18n.t('pageTitle.newsEdit'),
        },
      },
      {
        path: 'galleries',
        name: 'Galleries',
        component: Galleries,
        meta: {
          title: i18n.t('pageTitle.galleries'),
        },
      },
      {
        path: 'socials',
        name: 'Socials',
        component: Socials,
        meta: {
          title: i18n.t('pageTitle.socials'),
        },
        beforeEnter: ifAdmin,
      },
      {
        path: 'contributions',
        name: 'Contributions',
        component: Contributions,
        meta: {
          title: i18n.t('pageTitle.contributions'),
        },
        beforeEnter: ifAdmin,
      },
      {
        path: 'pages',
        name: 'Pages',
        component: Pages,
        meta: {
          title: i18n.t('pageTitle.pages'),
        },
        beforeEnter: ifAdmin,
      },
    ],
    beforeEnter: ifAuthenticated,
  },
];
